/**
 * A function to manually resize a chart when its x axis tick labels are too long, like job names.
 * This can't be done dynamically because that's just kind of how SVGs work, and because Recharts doesn't offer 
 * any sort of callback or event when it's done rendering.
 * @param containerElement The ref.current from the chart wrapper component
 */
export const resizeChartToFitLabels = (containerElement: HTMLSpanElement): void => {
    const responsiveContainer = containerElement.querySelector(".recharts-responsive-container");
    const cartesianGrid = containerElement.querySelector(".recharts-cartesian-grid");
    const rechartsSurface = containerElement.querySelector(".recharts-surface");
    const currentViewBoxWidth = rechartsSurface.getAttribute("viewBox")?.split(" ")[2];
    const xAxisLabel = containerElement.querySelector(".xAxis .recharts-label");
    const xLabelSpacing = xAxisLabel ? 16 : 0;

    // move the axis label first because it changes the height of the xAxis below
    if (xAxisLabel) {
        const xAxisTicksHeight = (containerElement.querySelector(".xAxis .recharts-cartesian-axis-ticks") as SVGGraphicsElement).getBBox().height;
        xAxisLabel.setAttribute("y", (cartesianGrid.getBoundingClientRect().height + xAxisTicksHeight + xLabelSpacing).toString());
    }
    const realChartHeight = Math.round(
        cartesianGrid?.getBoundingClientRect().height +
        containerElement.querySelector(".xAxis")?.getBoundingClientRect().height +
        xLabelSpacing * 2
    );

    responsiveContainer.setAttribute("height", realChartHeight.toString());
    (responsiveContainer as HTMLElement).style.height = `${realChartHeight}px`;

    rechartsSurface.setAttribute("height", realChartHeight.toString());
    rechartsSurface.setAttribute("viewBox", `0 0 ${currentViewBoxWidth} ${realChartHeight}`);
}
